import type { UseQueryResult } from '@tanstack/react-query';

import { postJson, useApi } from './api';

export type AuthConfig = { mode: 'google' | 'proxy' | 'local' | 'none'; google_client_id: string | null };

export function useAuthConfig(): UseQueryResult<AuthConfig, Error> {
  return useApi<AuthConfig>('/auth/config');
}

export async function signIn(code: string): Promise<void> {
  await postJson('/auth/google', { code });
}

export async function signOut(): Promise<void> {
  await postJson('/auth/logout');
}
